import getConfig from 'next/config';

const {
    publicRuntimeConfig: { apiUrl },
} = getConfig();

export const V2_URL = apiUrl + '/api/v2';
